<template>
  <v-autocomplete
      :label="label"
      item-text="name"
      item-value="dbid"
      autocomplete
      clearable
      required
      :rules="xRules.required"
      :loading="userLoading"
      :items="userItems"
      :search-input.sync="userSearch"
      v-model="user"
      :return-object="true"
      hint="输入姓名关键词，按回车键检索，并选择用户。"
      persistent-hint
  >
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title>
          {{ data.item.name }} / {{ data.item.number }}{{ formatTitle(data.item.title) }}{{ formatAge(data.item.birthday) }}
        </v-list-tile-title>
        <v-list-tile-sub-title>{{ formatDept(data.item.deptRoles) }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: ['value', 'label', 'hint', 'persistent-hint', 'rules'],

  data() {
    return {
      userURI: '/api/syst/user/search',
      user: null,
      userSearch: '',
      userLoading: false,
      userItems: [],
      xRules: {
        required: [v => !!v || '必填项。']
      }
    };
  },

  created() {
    this.initializeValue(this.value);
  },

  watch: {
    value: {
      handler(val) {
        this.initializeValue(val);
      },
      immediate: true
    },

    user(u) {
      if (u && typeof u === 'object') {
        this.$emit('input', u);
      } else {
        this.$emit('input', null);
      }
    },

    // 👇 修复后的 userSearch 监听
    userSearch(val) {
      const search = (val || '').trim();
      if (search.length >= 1) {
        this.onUserSearch(search);
      } else {
        // 搜索框清空时，恢复为仅显示当前选中项（或空）
        this.userItems = this.user ? [this.user] : [];
      }
    }
  },

  methods: {
    initializeValue(val) {
      if (!val) {
        this.user = null;
        this.userItems = [];
        return;
      }

      // 情况1：已经是完整用户对象（有 name）
      if (typeof val === 'object' && val.name) {
        this.user = val;
        this.userItems = [val];
        return;
      }

      // 情况2：是 ID（字符串或数字）
      let userId = null;
      if (typeof val === 'string' || typeof val === 'number') {
        userId = val;
      } else if (typeof val === 'object') {
        userId = val.dbid || val.userId;
      }

      if (userId) {
        // 避免重复请求相同用户
        const currentId = this.user ? (this.user.dbid || this.user.userId) : null;
        if (currentId == userId) return;

        this.fetchUserById(userId);
      } else {
        this.user = null;
        this.userItems = [];
      }
    },

    fetchUserById(id) {
      this.userLoading = true;
      const vm = this;

      // 假设后端支持 GET /api/syst/user/{id} 返回单个用户对象
      this.axios.get(this.userURI + id)
          .then(rsp => {
            const user = rsp.data; // 请根据实际 API 调整，如 rsp.data.data
            if (user && (user.name || user.dbid)) {
              this.user = user;
              this.userItems = [user];
            } else {
              this.user = null;
              this.userItems = [];
            }
          })
          .catch(err => {
            console.error('Failed to load user by ID:', id, err);
            this.user = null;
            this.userItems = [];
          })
          .finally(() => {
            this.userLoading = false;
          });
    },

// 👇 修复后的 onUserSearch
    onUserSearch(name) {
      if (!name || typeof name !== 'string' || name.trim() === '') return;
      const vm = this;
      const param = window.xutil.param('name', name.trim());
      this.userLoading = true;

      this.axios.get(vm.userURI, { params: param })
          .then(rsp => {
            const items = rsp.data.items || [];
            this.userItems = items;
            if (this.user) {
              const exists = items.some(item =>
                  item.dbid === this.user.dbid || item.userId === this.user.userId
              );
              if (!exists) {
                this.userItems.unshift(this.user);
              }
            }
          })
          .catch(() => {
            this.userItems = this.user ? [this.user] : [];
          })
          .finally(() => {
            this.userLoading = false;
          });
    },

    formatAge(birthday) {
      let age = null;
      if (birthday) {
        age = new Date(new Date() - new Date(birthday)).getFullYear() - 1970;
      }
      return age ? ` / ${age}岁` : '';
    },

    formatTitle(title) {
      return title ? ` / ${title.name}` : '';
    },

    formatDept(deptRoles) {
      if (!Array.isArray(deptRoles)) return '';
      return deptRoles
          .map(dr => dr.department && dr.department.name)
          .filter(Boolean)
          .filter((v, i, a) => a.indexOf(v) === i) // 简易去重（替代 .unique()）
          .join(', ');
    }
  }
};
</script>